const attention = {
  open: '通知を開く',
  close: '通知を閉じる',
  title: '通知',
  intro: '確認が必要な新規リード、有人対応依頼、応答期限をまとめて表示します。',
  unreadCount: '未読 {count} 件',
  markAll: 'すべて既読',
  filter: { all: 'すべて', unread: '未読', lead: '新規リード', human: '有人対応' },
  kind: {
    lead_created: '有効な新規リードを受信',
    human_handoff_requested: '購入者が有人対応を依頼',
    sla_warning: '初回応答期限が近づいています',
    sla_overdue: '応答期限を過ぎました',
  },
  body: {
    lead_created: '購入者が連絡を許可しました。該当リードで対応を続けてください。',
    human_handoff_requested: '元の Airlock 会話、または作成済みの関連リードを開いてください。',
    sla_warning: 'このリードには現在の段階で必要な担当者の操作がまだありません。',
    sla_overdue: '固定された応答期限を過ぎていますが、必要な操作が完了していません。',
  },
  target: { lead: 'リード詳細', conversation: '受付の元会話' },
  openTarget: '対応する',
  markRead: '既読にする',
  read: '既読',
  unread: '未読',
  urgent: '優先',
  emptyTitle: '確認が必要な項目はありません',
  emptyBody: '新しい業務イベントはここに表示されますが、ワークフロー状態は変更しません。',
  loading: '新しい通知を確認中…',
  failed: '通知を読み込めませんでした。',
  retry: '再試行',
  newToast: '新しい通知が {count} 件あります',
  boundary: '既読はこの受信箱だけの状態です。割当、フォロー、結果はリードの流れで完了します。',
  emailBoundary: 'メールは企業設定に従います。送信失敗でもアプリ内通知は失われません。',
  justNow: 'たった今',
  minutesAgo: '{count} 分前',
  hoursAgo: '{count} 時間前',
  daysAgo: '{count} 日前',
} as const

export default attention
